// Casino Dashboard › Users
//
// Ported from casino_dashboard/src/layouts/users — the lifetime per-player
// deposit / SC purchase / withdrawal roll-up from GET /dashboard/transaction.
import React from "react";
import { Box, Button } from "@mui/material";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import PageHeader from "../../components/PageHeader";
import SectionCard from "../../components/SectionCard";
import DataTable from "../../components/DataTable";
import DashboardService from "../../Utility/dashboardService";
import { StateLine, errText, fixed } from "./shared";

const columns = [
  { header: "Name", accessor: "name", align: "left" },
  { header: "Email", accessor: "email", align: "left" },
  { header: "Player Type", accessor: "playerType", align: "left" },
  { header: "Total Deposit", accessor: "totalDeposit", align: "center" },
  { header: "Total SC Buy", accessor: "totalScCoins", align: "center" },
  { header: "Total Withdrawal", accessor: "totalWithdrawal", align: "center" },
];

export default function CasinoUsers() {
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);
  const [tick, setTick] = React.useState(0);

  React.useEffect(() => {
    let active = true;
    setLoading(true);
    setError(null);
    (async () => {
      try {
        const result = await DashboardService.getData("/dashboard/transaction");
        if (active) setRows(Array.isArray(result?.data) ? result.data : []);
      } catch (e) {
        if (active) setError(errText(e));
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => {
      active = false;
    };
  }, [tick]);

  const tableRows = React.useMemo(
    () =>
      rows.map((u) => ({
        name: u.name,
        email: u.email,
        playerType: u.playerType || "—",
        totalDeposit: `$${fixed(u.totalDeposit)}`,
        totalScCoins: fixed(u.totalScCoins),
        totalWithdrawal: `$${fixed(u.totalWithdrawal)}`,
      })),
    [rows]
  );

  return (
    <Box>
      <PageHeader
        title="Users"
        crumb="Casino Dashboard / Users"
        subtitle="Lifetime deposits, SC purchases and withdrawals per player"
        actions={
          <Button
            size="small"
            variant="outlined"
            color="inherit"
            startIcon={<RefreshRoundedIcon />}
            onClick={() => setTick((t) => t + 1)}
            disabled={loading}
          >
            Refresh
          </Button>
        }
      />

      <SectionCard title="Users" sx={{ p: 2, height: "auto" }}>
        <StateLine error={error} />
        {!error && (
          <DataTable
            columns={columns}
            rows={tableRows}
            loading={loading}
            searchable
            sortable
            paginated
            entriesPerPage
            showTotalEntries
            searchPlaceholder="Search name, email or player type…"
            emptyText="No users found."
          />
        )}
      </SectionCard>
    </Box>
  );
}
